export default __webpack_public_path__ + "static/media/5516.61acb224.png";